<template>
    <div class="m-auto" data-cy="container_history_getfriend_share">
        <div class="flex items-center bg-white border border-a-gray-d6d6d6 rounded-lg p-4">
            <div>
                <div class="text-12 text-a-gray-666666" data-cy="text_history_getfriend_code_label">{{ lbl.history.mission.fgf_code }}</div>
                <div class="flex items-center gap-2 pt-0.5"
                    data-cy="btn_history_getfriend_copy_code"
                    v-clipboard:copy="userCode"
                    @click="onCopy($event)">
                    <div class="text-a-blue-0064ff text-18 font-bold" data-cy="text_history_getfriend_code">{{ userCode }}</div>
                    <img :src="icCopyUrls()" class="w-3" alt="copy" data-cy="icon_history_getfriend_copy" />
                </div>
            </div>
            <!-- <div class="ml-auto">
                <img src="@/assets/icon/ic-share.svg" class="w-7" alt="share" />
            </div> -->
        </div>
    </div>
</template>
<script>
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
import ErrorApiMixin from '@/mixin/ErrorApiMixin';
import ModalMixin from '@/mixin/ModalMixin';
//helper
import Account from '@/helper/AccountHelper.js';
import ConfigManager from "@/config/ConfigManager.js";

export default {
    name: 'GetFriendShare',
    mixins: [LocaleMixin, ErrorApiMixin, ModalMixin],
    components: {
    },
    data: function() {
        return {
            isLoaded: false,
            userCode: '',
        };
    },
    created: async function() {
        this.userCode = Account.getUserCode();
    },
    methods: {
        onCopy: function() {
            this.modal.copySerialSuccessModal
                .clearModal()
                .show()

            this.tracking.event('me_cart', 'click_me_cart', null, null);
        },
        icCopyUrls: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/icons/ic-copy-fgf.svg`;
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
